import CustomButton from 'components/Buttons/CustomButton'
import ProfilePic from 'components/PMBProfilePic'
import { Can } from 'context/Acl'
import { useEffect, useState } from 'react'
import { useIntl } from 'react-intl'
import { useDispatch, useSelector } from 'react-redux'
import { Card, CardBody, Col, Row, Spinner } from 'reactstrap'
import { BUSINESS_AR_AP, BUSINESS_AR_AP_COMPANY, MANAGE } from 'utils/subjectActions'
import { toggleModalAdjustReceivable } from '../receivable-notes/receivableNotesSlice'
import ModalAdjustPayable from './ModalAdjustPayable'
import { getDetailPayable, getDetailPayablePersonal } from './payableAction'
import { toggleModalAdjust } from './payableNotesSlice'
import { P } from 'components'
import ExpandableNoteList from 'components/ExpandableNoteList'
import { useLocation, useNavigate } from 'react-router-dom'
import { ArrowLeft, User } from 'react-feather'
import { getTimelineItem } from 'helpers'
import { URL_DETAIL_TRANSACTION } from 'utils/pathUrl'
import PMBModalImagePreview from 'components/PMBModalImagePreview'
import ImageCrash from 'assets/images/404.png'
import { formatDatePMB, formatDatePMBV2 } from 'utils/formatDate'
import ICTunai from 'assets/icons/currency-dollar.svg'
import ICUangBelanja from 'assets/icons/uang-belanja-wallet.png'
import { TableComponent } from 'components/TableComponent'
import { useDownloadInvoicePayableMutation } from './payableNotesApiSlice'
import { Download } from 'react-feather'
import { enqueueSnackbar } from 'notistack'
import { useAbilityAccess } from 'hooks/useAbilityAccess'

const DetailPage = ({ isReceivable }) => {
  const intl = useIntl()
  const dispatch = useDispatch()
  const location = useLocation()
  const navigate = useNavigate()
  const searchParams = new URLSearchParams(location.search)
  const row = location.state?.row
  const id = searchParams.get('id')
  const [modalOpenImage, setModalOpenImage] = useState(false)

  const [downloadInvoicePayable, { isLoading: isDownloadingInvoice }] = useDownloadInvoicePayableMutation()

  const hasPersonalAbilityMANAGE = useAbilityAccess({ action: MANAGE, subject: BUSINESS_AR_AP })
  const hasCompanyAbilityMANAGE = useAbilityAccess({ action: MANAGE, subject: BUSINESS_AR_AP_COMPANY })

  const handleDownloadInvoice = async () => {
    try {
      const blob = await downloadInvoicePayable({ id: data?.id || id }).unwrap()
      if (blob) {
        const url = window.URL.createObjectURL(blob)
        const a = document.createElement('a')
        a.href = url
        a.download = `Invoice_${data?.invoiceNumber || data?.id || id}.pdf`
        document.body.appendChild(a)
        a.click()
        a.remove()
        window.URL.revokeObjectURL(url)
      } else {
        enqueueSnackbar('Gagal mengunduh invoice: Data kosong', { variant: 'error' })
      }
    } catch (error) {
      enqueueSnackbar(
        error?.data?.message || error?.error || error?.message || 'Gagal mengunduh invoice',
        { variant: 'error' }
      )
    }
  }

  const { isOpenModalAdjust: isOpenModalAdjustReceivable } = useSelector(
    (state) => state.receivableNotes,
  )

  const {
    isOpenModalAdjust,
    detail: data,
    loading,
    type
  } = useSelector((s) => s.payableNotes)

  const isPaidOff = (data?.amount ?? 0) - (data?.amountPaid ?? 0) <= 0

  const actionGetDetailPayable = type === 'personal' ? getDetailPayablePersonal : getDetailPayable

  useEffect(() => {
    if (id) {
      dispatch(actionGetDetailPayable({ id: id }))
    }
  }, [id, actionGetDetailPayable])


  const mergedColumns = [
    {
      name: <span>Nomor Invoice</span>,
      minWidth: '150px',
      selector: (rowItem) => rowItem?.invoiceNumber || '-',
      cell: (rowItem) => <div>{rowItem?.invoiceNumber || '-'}</div>,
    },
    {
      name: <span>Tanggal</span>,
      minWidth: '150px',
      selector: (rowItem) => formatDatePMBV2(rowItem?.createdAt) || '-',
      cell: (rowItem) => (
        <div>{formatDatePMBV2(rowItem?.createdAt) || '-'}</div>
      ),
    },
    {
      name: <span>Total</span>,
      minWidth: '150px',
      right: true,
      selector: (rowItem) => rowItem?.amount ?? 0,
      cell: (rowItem) => (
        <div className="text-end">
          Rp
          {intl.formatNumber(rowItem?.amount ?? 0, {
            useGrouping: 'always',
            minimumFractionDigits: 0,
            maximumFractionDigits: 2,
          })}
        </div>
      ),
    },
    {
      name: <span></span>,
      minWidth: '180px',
      right: true,
      cell: (rowItem) =>
        rowItem?.escrowpaymentId || data?.escrowpaymentId ? (
          <CustomButton
            outline
            color="primary"
            size="sm"
            onClick={() => {
              navigate(
                `${URL_DETAIL_TRANSACTION}/${rowItem?.escrowpaymentId ?? data?.escrowpaymentId}?type=${rowItem?.orderDetail?.type ? rowItem?.orderDetail?.type : isReceivable ? 'SELL' : 'BUY'}`,
              )
            }}
          >
            Lihat Detail Transaksi
          </CustomButton>
        ) : null,
    },
  ]

  return (
    <>
      <PMBModalImagePreview
        isOpen={modalOpenImage}
        toggle={() => setModalOpenImage(!modalOpenImage)}
        images={
          Array.isArray(data?.files)
            ? data?.files
            : JSON.parse(data?.files || '[]')
        }
        isDownload
      />
      <ModalAdjustPayable
        row={[data]}
        isReceivable={isReceivable}
        isOpen={isReceivable ? isOpenModalAdjustReceivable : isOpenModalAdjust}
        toggle={() =>
          dispatch(
            isReceivable ? toggleModalAdjustReceivable() : toggleModalAdjust(),
          )
        }
        refetch={() => {
          dispatch(actionGetDetailPayable({ id: id }))
        }}
      />

      {loading ? (
        <div className="d-flex justify-content-center">
          <Spinner />
        </div>
      ) : (
        <div className="py-3">
          <Row className="align-items-start mb-3 ">
            <Col
              xs="12"
              md="6"
              className="d-flex gap-1 align-items-center mb-2 mb-md-0"
            >
              <ArrowLeft
                size={20}
                className="me-2"
                style={{ cursor: 'pointer' }}
                onClick={() => navigate(-1)}
              />
              <h6 className="fw-bold mb-0">
                Detail {isReceivable ? 'Piutang' : 'Utang'}
              </h6>
            </Col>
            <Col xs="12" md="6" className="text-md-end d-flex justify-content-md-end gap-2">
              <CustomButton
                outline
                color="primary"
                onClick={handleDownloadInvoice}
                disabled={isDownloadingInvoice}
              >
                {isDownloadingInvoice ? <Spinner size="sm" /> : <><Download size={16} className="me-2" /> Unduh Invoice</>}
              </CustomButton>

              {(hasCompanyAbilityMANAGE || hasPersonalAbilityMANAGE) && <>
                {data?.amount === data?.amountPaid ? null : (
                  <CustomButton
                    onClick={() =>
                      dispatch(
                        isReceivable
                          ? toggleModalAdjustReceivable()
                          : toggleModalAdjust(),
                      )
                    }
                    disabled={data?.mergeToPayableId}
                    color="primary"
                  >
                    {data?.manual || !data?.escrowpaymentId
                      ? `Sesuaikan ${isReceivable ? 'Piutang' : 'Utang'}`
                      : isReceivable
                        ? 'Sesuaikan Piutang'
                        : 'Bayar Utang'}
                  </CustomButton>
                )}
              </>}

            </Col>
          </Row>

          <Row className="">
            <Col md="6" className="">
              <Card className="shadow-sm border-0 h-100">
                <CardBody>
                  <h6 className="fw-semibold mb-3">
                    Informasi {`${isReceivable ? 'Piutang' : 'Utang'}`}
                  </h6>
                  <Row className="mb-3">
                    <Col xs="6" className="fw-light text-sm">
                      Tanggal
                    </Col>
                    <Col xs="6" className="fw-semibold text-sm">
                      {formatDatePMBV2(data?.createdAt) || '-'}
                    </Col>
                  </Row>
                  <Row className="mb-3">
                    <Col xs="6" className="fw-light text-sm">
                      Nomor Invoice
                    </Col>
                    <Col xs="6" className="fw-semibold text-sm">
                      {data?.invoiceNumber || '-'}
                    </Col>
                  </Row>
                  <Row className="mb-3">
                    <Col xs="6" className="fw-light text-sm">
                      Status
                    </Col>
                    <Col xs="6" className="fw-semibold text-sm">
                      {(() => {
                        const status = data?.status?.toLowerCase()
                        let className = 'badge rounded-pill px-2'

                        if (status === 'paid') {
                          className += ' bg-success-50 text-success'
                        } else if (status === 'open') {
                          className += ' bg-warning-50 text-warning-700'
                        } else {
                          className += ' bg-primary-50 text-primary'
                        }

                        return (
                          <div>
                            <div className={className}>{data?.status}</div>
                          </div>
                        )
                      })()}
                    </Col>
                  </Row>
                  <Row className="mb-3">
                    <Col xs="6" className="fw-light text-sm">
                      Tipe
                    </Col>
                    <Col xs="6" className="fw-semibold text-sm">
                      <div
                        className={`badge rounded-pill ${data?.manual || (!data?.escrowpaymentId && !(data?.mergedPayables?.length > 0)) ? 'bg-warning-50 text-warning-700' : 'bg-success-50 text-success'} px-2`}
                        style={{
                          wordBreak: 'break-word',
                        }}
                      >
                        {data?.manual ||
                          (!data?.escrowpaymentId &&
                            !(data?.mergedPayables?.length > 0))
                          ? 'Catat Manual'
                          : 'Transaksi'}
                      </div>
                    </Col>
                  </Row>
                  <Row className="mb-3">
                    <Col xs="6" className="fw-light text-sm">
                      Kategori
                    </Col>
                    <Col xs="6" className="fw-semibold text-sm">
                      {data?.category?.label || '-'}
                    </Col>
                  </Row>
                  {(data?.detail?.project && type === 'company') && (
                    <Row className="mb-3">
                      <Col xs="6" className="fw-light text-sm">
                        Proyek
                      </Col>
                      <Col xs="6" className="fw-semibold text-sm">
                        {data?.detail?.project?.label ||
                          data?.detail?.project?.title ||
                          '-'}
                      </Col>
                    </Row>
                  )}
                  <Row className="mb-3">
                    <Col xs="6" className="fw-light text-sm">
                      {isReceivable ? 'Piutang' : 'Utang'} kepada
                    </Col>
                    <Col xs="6" className="fw-semibold text-sm">
                      {(() => {
                        const displayName = data?.manual || !data?.escrowpaymentId
                          ? isReceivable
                            ? data?.payerName ||
                            row?.buyerName ||
                            data?.buyer?.name ||
                            '-'
                            : data?.payeeName ||
                            row?.sellerName ||
                            data?.seller?.name ||
                            '-'
                          : isReceivable
                            ? data?.buyer?.name ||
                            row?.buyerName ||
                            data?.payerName ||
                            '-'
                            : data?.seller?.name ||
                            row?.sellerName ||
                            data?.payeeName ||
                            '-'

                        const partnershipName = isReceivable
                          ? data?.buyer?.partnership?.name || row?.buyerPartnershipName
                          : data?.seller?.partnership?.name || row?.sellerPartnershipName

                        const avatarSrc = isReceivable
                          ? data?.buyer?.profilePhoto || data?.buyer?.partnership?.logo || row?.buyerPartnershipLogo
                          : data?.seller?.profilePhoto || data?.seller?.partnership?.logo || row?.sellerPartnershipLogo

                        const avatarSeed = isReceivable
                          ? data?.buyer?.userId || row?.payerUserId
                          : data?.seller?.userId || row?.userId

                        return (
                          <div className="d-flex align-items-start gap-2">
                            <ProfilePic
                              imgSrc={avatarSrc}
                              altText={displayName}
                              name={displayName}
                              avatarSeed={avatarSeed}
                              width={28}
                              height={28}
                            />
                            <div
                              className="d-flex flex-column"
                              style={{
                                minWidth: 0,
                                lineHeight: '1.3',
                              }}
                            >
                              <span
                                className="fw-medium"
                                style={{
                                  wordBreak: 'break-word',
                                }}
                              >
                                {displayName}
                              </span>

                              {partnershipName && (
                                <div
                                  className="d-flex flex-column"
                                  style={{ marginTop: '2px' }}
                                >
                                  <span
                                    className="text-primary fw-semibold"
                                    style={{
                                      fontSize: '0.8rem',
                                      wordBreak: 'break-word',
                                    }}
                                  >
                                    {partnershipName}
                                  </span>
                                </div>
                              )}
                            </div>
                          </div>
                        )
                      })()}
                    </Col>
                  </Row>
                  <Row className="mb-3">
                    <Col xs="6" className="fw-light text-sm">
                      Total {isReceivable ? 'piutang' : 'utang'}
                    </Col>
                    <Col xs="6" className="fw-semibold text-sm">
                      Rp
                      {intl.formatNumber(data?.amount ?? 0, {
                        useGrouping: 'always',
                        minimumFractionDigits: 0,
                        maximumFractionDigits: 2,
                      })}
                    </Col>
                  </Row>
                  <Row className="mb-3">
                    <Col xs="6" className="fw-light text-sm">
                      Sisa {isReceivable ? 'piutang' : 'utang'}
                    </Col>
                    <Col xs="6" className="fw-semibold text-sm">
                      Rp
                      {intl.formatNumber(
                        (data?.amount ?? 0) - (data?.amountPaid ?? 0),
                        {
                          useGrouping: 'always',
                          minimumFractionDigits: 0,
                          maximumFractionDigits: 2,
                        },
                      )}
                    </Col>
                  </Row>
                  <Row className="mb-3">
                    <Col xs="6" className="fw-light text-sm">
                      Dibayar
                    </Col>
                    <Col xs="6" className="fw-semibold text-sm">
                      Rp
                      {intl.formatNumber(data?.amountPaid ?? 0, {
                        useGrouping: 'always',
                        minimumFractionDigits: 0,
                        maximumFractionDigits: 2,
                      })}
                    </Col>
                  </Row>
                  <Row className="mb-3">
                    <Col xs="6" className="fw-light text-sm">
                      Catatan
                    </Col>
                    <Col xs="6" className="fw-semibold text-sm text-break">
                      <ExpandableNoteList notes={data?.notes || '-'} />
                    </Col>
                  </Row>
                  {(row?.escrowpaymentId || data?.escrowpaymentId) && (
                    <CustomButton
                      outline
                      color="primary"
                      style={{ width: '100%' }}
                      onClick={() => {
                        navigate(
                          `${URL_DETAIL_TRANSACTION}/${row?.escrowpaymentId ?? data?.escrowpaymentId}?type=${row?.orderDetail?.type ? row?.orderDetail?.type : isReceivable ? 'SELL' : 'BUY'}`,
                        )
                      }}
                    >
                      Lihat Detail Transaksi
                    </CustomButton>
                  )}
                </CardBody>
              </Card>
            </Col>

            <Col md="6" className="">
              <Card className="shadow-sm border-0 h-100">
                <CardBody>
                  <h6 className="fw-semibold mb-3">Riwayat Pembayaran</h6>
                  <div style={{ maxHeight: '400px', overflowY: 'auto' }}>
                    {data?.history?.length > 0 ? (
                      data?.history?.map((e, i) => {
                        const imageFiles = e?.paymentBulkHistory?.files?.filter(
                          (a) => /\.(jpg|jpeg|png|gif|webp)$/i.test(a),
                        )
                        const pdfFiles = e?.paymentBulkHistory?.files?.filter(
                          (a) => /\.pdf$/i.test(a),
                        )

                        const primaryFile =
                          imageFiles?.[0] || pdfFiles?.[0] || null
                        const isPdf = /\.pdf$/i.test(primaryFile)

                        const paymentMethod =
                          e?.paymentBulkHistory?.paymentMethod ||
                          e?.paymentMethod

                        const renderPaymentMethod = () => {
                          if (paymentMethod === 'cashpayment') {
                            return (
                              <div
                                className="badge rounded-pill bg-gray-100 text-gray-700 px-2 py-1 gap-1"
                                style={{
                                  display: 'inline-flex',
                                  alignItems: 'center',
                                  justifyContent: 'center',
                                  whiteSpace: 'normal',
                                  wordBreak: 'break-word',
                                  width: 'fit-content',
                                }}
                              >
                                <img
                                  width={18}
                                  height={18}
                                  src={ICTunai}
                                  alt={'Tunai'}
                                />{' '}
                                Tunai
                              </div>
                            )
                          } else if (paymentMethod === 'uangbelanja') {
                            return (
                              <div
                                className={`badge rounded-pill bg-primary-50 px-2 py-1 gap-1`}
                                style={{
                                  display: 'inline-flex',
                                  alignItems: 'center',
                                  justifyContent: 'center',
                                  whiteSpace: 'normal',
                                  wordBreak: 'break-word',
                                  width: 'fit-content',
                                }}
                              >
                                <img
                                  width={16}
                                  height={16}
                                  src={ICUangBelanja}
                                  alt={'Uang Belanja'}
                                />
                                <span className={'text-primary'}>
                                  Uang Belanja
                                </span>
                              </div>
                            )
                          } else if (paymentMethod === 'paymentviaagent') {
                            return (
                              <div
                                className="badge rounded-pill text-primary-v2 bg-primary-50 px-2 py-1 gap-1"
                                style={{
                                  display: 'inline-flex',
                                  alignItems: 'center',
                                  justifyContent: 'center',
                                  whiteSpace: 'normal',
                                  wordBreak: 'break-word',
                                  width: 'fit-content',
                                }}
                              >
                                <User size={14} /> Pembayaran Melalui Agen
                              </div>
                            )
                          } else if (paymentMethod === 'adjustbyseller') {
                            return (
                              <div
                                className="badge rounded-pill bg-warning bg-opacity-10 text-warning px-2 py-1 gap-1"
                                style={{
                                  display: 'inline-flex',
                                  alignItems: 'center',
                                  justifyContent: 'center',
                                  whiteSpace: 'normal',
                                  wordBreak: 'break-word',
                                  width: 'fit-content',
                                }}
                              >
                                Penyesuaian Penjual
                              </div>
                            )
                          } else {
                            return <div>-</div>
                          }
                        }

                        return getTimelineItem(
                          <div className="d-flex flex-column">
                            <P>
                              {isReceivable ? 'Terima pembayaran' : 'Bayar'} Rp
                              {intl.formatNumber(e?.amountPaid ?? 0, {
                                useGrouping: 'always',
                                minimumFractionDigits: 0,
                                maximumFractionDigits: 2,
                              })}
                            </P>
                            <div style={{ marginTop: '6px' }}>
                              {renderPaymentMethod()}
                            </div>
                            <small style={{ color: '#667085' }}>
                              {formatDatePMBV2(e?.createdAt)}
                            </small>

                            {e?.notes || e?.paymentBulkHistory?.note ? (
                              <div
                                style={{
                                  display: 'flex',
                                  flexWrap: 'wrap',
                                  maxWidth: '100%',
                                }}
                              >
                                <P
                                  size="regular"
                                  className="text-secondary"
                                  style={{
                                    fontStyle: 'italic',
                                    wordBreak: 'break-word',
                                    overflowWrap: 'break-word',
                                    whiteSpace: 'normal',
                                    maxWidth: '100%',
                                  }}
                                >
                                  "{e?.notes || e?.paymentBulkHistory?.note}"
                                </P>
                              </div>
                            ) : null}

                            {e?.paymentBulkHistory?.files?.length > 0 && (
                              <div
                                style={{
                                  position: 'relative',
                                  width: '70px',
                                  height: '70px',
                                  overflow: 'hidden',
                                  borderRadius: '8px',
                                  marginTop: '8px',
                                  boxShadow: '0 4px 8px rgba(0, 0, 0, 0.1)',
                                  border: '1px solid #f0f0f0',
                                  display: 'flex',
                                  justifyContent: 'center',
                                  alignItems: 'center',
                                  backgroundColor: '#f9f9f9',
                                  cursor: 'pointer',
                                }}
                                onClick={(event) => {
                                  setModalOpenImage(true)
                                }}
                              >
                                {isPdf ? (
                                  <>
                                    <div className="text-center">
                                      <i
                                        className="fa fa-file-pdf-o text-danger"
                                        style={{ fontSize: 28 }}
                                      ></i>
                                      <div style={{ fontSize: '10px' }}>
                                        PDF
                                      </div>
                                    </div>
                                  </>
                                ) : (
                                  <img
                                    src={primaryFile}
                                    onError={(e) => {
                                      e.currentTarget.onerror = null
                                      e.currentTarget.src = ImageCrash
                                    }}
                                    alt="arap-attachment"
                                    loading="lazy"
                                    style={{
                                      width: '100%',
                                      height: '100%',
                                      objectFit: 'cover',
                                      transition: 'transform 0.2s ease-in-out',
                                    }}
                                    onMouseOver={(e) =>
                                    (e.currentTarget.style.transform =
                                      'scale(1.05)')
                                    }
                                    onMouseOut={(e) =>
                                    (e.currentTarget.style.transform =
                                      'scale(1)')
                                    }
                                  />
                                )}

                                {e?.paymentBulkHistory?.files?.length - 1 >
                                  0 && (
                                    <div
                                      style={{
                                        position: 'absolute',
                                        top: '4px',
                                        right: '4px',
                                        width: '20px',
                                        height: '20px',
                                        borderRadius: '50%',
                                        backgroundColor: 'rgba(0, 0, 0, 0.7)',
                                        color: 'white',
                                        display: 'flex',
                                        justifyContent: 'center',
                                        alignItems: 'center',
                                        fontSize: '10px',
                                        fontWeight: 'bold',
                                        border: '1px solid #fff',
                                      }}
                                    >
                                      +{e?.paymentBulkHistory?.files?.length - 1}
                                    </div>
                                  )}
                              </div>
                            )}
                          </div>,
                          null,
                        )
                      })
                    ) : (
                      <span>
                        Belum ada pembayaran{' '}
                        {isReceivable ? 'yang diterima' : ''}
                      </span>
                    )}
                  </div>
                </CardBody>
              </Card>
            </Col>
          </Row>

          {data?.mergedPayables?.length > 0 && (
            <Row className="mt-4">
              <Col md="12">
                <Card className="shadow-sm border-0 h-100">
                  <CardBody>
                    <h6 className="fw-semibold mb-3">
                      Daftar {isReceivable ? 'Piutang' : 'Utang'} yang
                      Digabungkan
                    </h6>
                    <div className="w-100">
                      <TableComponent
                        columns={mergedColumns}
                        data={data?.mergedPayables || []}
                        pagination={false}
                        progressPending={loading}
                      />
                    </div>
                  </CardBody>
                </Card>
              </Col>
            </Row>
          )}
        </div>
      )}
    </>
  )
}

export default DetailPage
